import httpClient from "@/common/service/HttpClient";
import { endPoints } from "@/constants/apiSetting";
const LeavePlanService = {
  getLeavePlans(obj) {
    return httpClient.post(endPoints.getLeavePlans, obj);
  },
  deleteLeavePlan(obj) {
    return httpClient.post(endPoints.deleteLeavePlan, obj);
  },
  addLeavePlan(obj) {
    return httpClient.post(endPoints.addLeavePlan, obj);
  },
  updateLeavePlan(obj) {
    return httpClient.post(endPoints.updateLeavePlan, obj);
  }
};

export default LeavePlanService;



// WEBPACK FOOTER //
// ./src/service/LeavePlanService.js